import { render, staticRenderFns } from "./AccountSubscriptionOrders.vue?vue&type=template&id=45d1cad2&"
import script from "./AccountSubscriptionOrders.vue?vue&type=script&lang=ts&"
export * from "./AccountSubscriptionOrders.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSubscriptionOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports